import React, { useEffect, useState } from 'react';
import DetilnImg from '../components/pageStructure/DetilnImg';
import ImgLeftComp from '../components/pageStructure/ImgLeftComp';
import axios from 'axios';


const NigstCampus = () => {
  const [sports, setSports] = useState({ heading: "", text: [], images: [] });
  const [campus, setCampus] = useState({ heading: "", text: [], images: [] });
  const [hostel, setHostel] = useState({ heading: "", text: [], images: [] });

  const getSportsData = async () => {
    try {
      const url = "https://api.nigst.surveyofindia.gov.in/viewweb/view_web_sports_facility";
      const res = await axios.get(url);
      const data = res.data.data
      if (data.length > 0) {
        const heading =  "NIGST Sports";
        const text = data.map(item => item.description).filter(Boolean);
        const images = data.map(item => item.path).filter(Boolean);
        setSports({ heading, text, images });
      }
    } catch (error) {
      console.log(error)
    }
  }
    const getCampusData = async () => {
    try {
      const url = "https://api.nigst.surveyofindia.gov.in/viewweb/view_web_campus";
      const res = await axios.get(url);
      const data = res.data.data
      if (data.length > 0) {
        const heading =  "NIGST Campus";
        const text = data.map(item => item.description).filter(Boolean);
        const images = data.map(item => item.path).filter(Boolean);
        setCampus({ heading, text, images });
      }
    } catch (error) {
      console.log(error)
    }
  }
    const getHostelData = async () => {
    try {
      const url = "https://api.nigst.surveyofindia.gov.in/viewweb/view_web_nigst_hostel";
      const res = await axios.get(url);
      const data = res.data.data
      console.log(data)
      if (data.length > 0) {
        const heading =  "NIGST Hostel";
        const text = data.map(item => item.description).filter(Boolean);
        const images = data.map(item => item.path).filter(Boolean);
        setHostel({ heading, text, images });
      }
    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    getSportsData();
    getCampusData()
    getHostelData()
  }, [])

  return (
    <div className='m-2 md:m-4 p-2 md:p-6'>
      <DetilnImg heading={campus?.heading} text={campus?.text} images={campus?.images} />
      <ImgLeftComp heading={sports?.heading} text={sports?.text} images={sports?.images} />
      <DetilnImg heading={hostel?.heading} text={hostel?.text} images={hostel?.images} />
    </div>
  );
};

export default NigstCampus;
